export const NotificationFilterDates = [
    {
        name: 'Today',
        value: 'today'
    },
    {
        name: 'Yesterday',
        value: 'yesterday'
    },
    {
        name: 'This week',
        value: 'this_week'
    },
    {
        name: 'Last 7 days',
        value: 'last_7_days'
    },
    {
        name: 'This month',
        value: 'this_month'
    },
    {
        name: 'Last month',
        value: 'last_month'
    },
    {
        name: 'Last 6 months',
        value: 'last_6_months'
    },
    {
        name: 'This year',
        value: 'this_year'
    },
    {
        name: 'Last year',
        value: 'last_year'
    },
]